export default __webpack_public_path__ + "static/img-appworks-04b5852898e28fa56ec41f9914c7a4b3.png";